import { render } from "./AppError.vue?vue&type=template&id=5831d437"
import script from "./AppError.vue?vue&type=script&lang=js"
export * from "./AppError.vue?vue&type=script&lang=js"

import exportComponent from "/Users/david/Documents/GitHub/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"AppError.vue"]])

export default __exports__